<div class="modal-header" id="data-maintenance-system-config-modal-title">
    <h3 class="modal-title" translate="NOTIFICATION_DETAIL_DATA_MAINTENANCE_SYSCONFIG_TITLE"></h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" tabindex="0">
    <form [formGroup]="dataMaintenanceSysConfigForm">
        <fieldset formArrayName="formChildren">
            <div class="container-fluid">
                <div class="row table-header fw-bold py-2">
                    <div class="col-1"></div>
                    @for (column of model.tableModel.options.columns; track column; let isLast = $last) {
                        <div [ngClass]="isLast ? 'col-3' : 'col-4'">
                            <span (click)="doSort(column.field)">{{ column.title }}</span>
                            @if (reverseSort && orderByField === column.field && model.tableModel.rows.length > 0) {
                                <fa-icon [icon]="faSortDown"></fa-icon>
                            }
                            @if (!reverseSort && orderByField === column.field && model.tableModel.rows.length > 0) {
                                <fa-icon [icon]="faSortUp"></fa-icon>
                            }
                        </div>
                    }
                </div>

                @if (model.tableModel.rows.length === 0) {
                    <div class="text-center" translate="SORTABLE_LIST_EMPTY_TEXT_PLACEHOLDER"></div>
                }

                @if (model.tableModel.rows.length > 0) {
                    @for (row of model.tableModel.rows | orderBy: orderByField : reverseSort; track row) {
                        <pace-data-maintenance-sysconfig-expandable
                            [model]="model.tableModel"
                            [formChildren]="formChildren"
                            [technicalIdOrFunctionalLocationLabel]="strings.technicalIdOrFunctionalLocationLabel"
                            [displayReasonText]="false"
                            (modelValueChangedEvent)="modelValueChanged($event)"
                            [row]="row"
                            [columns]="model.tableModel.options.columns"
                        ></pace-data-maintenance-sysconfig-expandable>
                    }
                }
            </div>
        </fieldset>
    </form>
</div>
<div class="modal-footer">
    @if (!isLoading) {
        <button class="btn btn-primary" [disabled]="checkRowValidity() || !valueChanged" (click)="submit()">
            {{ strings.footer }}
        </button>
    }
    @if (isLoading) {
        <progressbar type="default" [striped]="true" [value]="100">Sending request...</progressbar>
    }
</div>
